import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { NewUserModalLayoutJSON } from "../Json/NewUserModalLayoutJson";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import {
  editModal,
  openModal,
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { getFilteredDataWithTabs } from "../../../../Utils/CommonService";
import { setNewUserFieldJson } from "../../../../slices/IpSettings/ipSettingsSlice";
import {
  createIpSettings,
  readIpSettings,
  readIpSettingsbyId,
  updateIpSettings,
} from "../IpSettingsService";
import useRezReactTable from "../../../../Components/Common/Tables/Tanstack/hooks/useRezReactTable";

const NewUserIpSettingsModal = () => {
  const modalShow = useSelector((state) => state.common.modalShow);

  const entityid = useSelector((state) => state.ipSettings.whiteListEdit);

  const ipSettingsFieldJson = useSelector(
    (state) => state.ipSettings.newUserModalFieldJson
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const enterpriseid = localStorage.getItem("enterpriseid");
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const rowsPerPage = useSelector((state) => state.common.pagination.size);
  const edit = useSelector((state) => state.common.editShow);

  const organizationId = selectedUser.organizationid;
  const [isPaginationReset, setIsPaginationReset] = useState(false);
  const { setPagination } = useRezReactTable();

  const dispatch = useDispatch();

  const resetPagination = () => {
    setIsPaginationReset(true);
    setPagination({
      page: 0,
      size: rowsPerPage,
    });
  };

  useEffect(() => {
    if (edit) {
      readIpSettingsbyId(entityid);
    }
  }, []);

  useEffect(() => {
    resetPagination();
  }, [rowsPerPage]);

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    // dispatch(setRolesEditID(null));
    dispatch(setSelectValidError(false));
  };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createOrganization(formState, parentId, organizationType);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const params = {
    page: 0,
    size: -1,
    sort_column: "mapped_user",
    sort_order: "ASC",
    listEntityType: "AGSU",
  };

  useEffect(() => {
    let mappedUser;
    const getMappedUser = async () => {
      mappedUser = await getFilteredDataWithTabs(
        "AGSU", // Replace with your actual entity type
        (data) => {
          // This is the callback function to handle the API response
          let customValues = data.map((i) => ({
            label: i.name,
            value: i.user_id,
          }));

          const updatedIpSettingsFieldJson = {
            ...ipSettingsFieldJson,
            "1719383709240-allmultiselect": {
              ...ipSettingsFieldJson["1719383709240-allmultiselect"],
              "data-customvalue": customValues,
            },
          };

          dispatch(setNewUserFieldJson(updatedIpSettingsFieldJson));
        },
        {}, // Pass the initial `data` object
        params, // Pass the initial `params` object
        null, // Example for activeTab, replace as needed
        null, // parentId
        organizationId, // organizationId
        null, // ownerId
        null, // enterpriseId
        null, // userId
        null, // organizationType
        organizationId, // organizationIdUser
        null, // parentId2
        null, // parentType
        null, // orgType
        null, // agId
        "ACTIVE"
      );
    };
    getMappedUser();
  }, []);

  const saveIpSetting = async (body, totalRows, rowsPerPage, e) => {
    e.preventDefault();

    const res = await createIpSettings(body, totalRows, rowsPerPage);
    if (res) {
      handleClose();
      // readIpSettings();
    }
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      updateIpSetting(body, formState.entityid);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  const { ip_address, description, mapped_userid_list, status } = formState;

  const body = {
    ip_address,
    description,
    mapped_userid_list,
    status,
  };

  const updateIpSetting = async (body, id, e) => {
    e.preventDefault();

    const res = await updateIpSettings(body, id);
    if (res) {
      handleClose();
      readIpSettings(id);
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
      size="lg"
    >
      <Form
        className="tablelist-form"
        onSubmit={(e) =>
          edit
            ? updateIpSetting(formState, formState.entityid, e)
            : saveIpSetting(formState, totalRows, rowsPerPage, e)
        }
      >
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {edit ? "Update IP Details" : "Add New IP"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {NewUserModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, ipSettingsFieldJson, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {/* <button
                type="button"
                className="btn btn-light"
                onClick={() => handleClose(false)}
              >
                Close
              </button> */}
                {/* <Button
                onClick={handleClose}
                className="primary primary_button"
                id="addNewMember"
              >
                {edit ? "Update" : "Cancel"}
              </Button> */}
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                  // onClick={() =>
                  //   edit
                  //     ? updateIpSetting(formState.entityid)
                  //     : saveIpSetting(formState, totalRows, rowsPerPage)
                  // }
                >
                  {edit ? "Update" : "Save"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default NewUserIpSettingsModal;
